import { useNavigate } from "hooks/useCustomNavigation";
import { useEffect } from "react";
import {
  DeviceVerificationButtons,
  DeviceVerificationHeader,
  DeviceVerificationInput
} from "components/UI/molecules";
import { INTERNAL_PATHS } from "routes/paths";
import { useAppContext } from "context/app-context";
import { useDeviceVerification } from "./utils/useDeviceVerification";
import "./index.scss";

export const DeviceVerification = () => {
  const navigate = useNavigate();
  const { sessionInfo } = useAppContext();
  const {
    hasSentCode,
    verificationMethod,
    sendVerificationCode,
    validateVerificationCode,
    codeToRaiseUser
  } = useDeviceVerification();

  useEffect(() => {
    if (!hasSentCode) navigate(INTERNAL_PATHS.DEVICE_VERIFICATION_NEW);
  }, [hasSentCode, navigate]);

  return (
    <div className="device-verification">
      <div className="device-verification-content">
        <DeviceVerificationHeader isStartPage={!hasSentCode} />
        {hasSentCode && (
          <DeviceVerificationInput
            validateCode={validateVerificationCode}
            codeToRaiseUser={codeToRaiseUser}
          />
        )}
        <DeviceVerificationButtons
          method={verificationMethod}
          phone={sessionInfo?.userPhone}
          sendCode={sendVerificationCode}
        />
        {!hasSentCode && (
          <p>
            This information is only used to keep your account safe and secure.
            If you are unable to verify your account, please chat with our Order
            Processing team if you believe you have received this message in
            error or have any questions.
          </p>
        )}
      </div>
    </div>
  );
};
